import React from "react";
import {
  Avatar,
  IconButton,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import Looks3Icon from "@mui/icons-material/Looks3";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from '@mui/icons-material/Info';

const SelectableProcessItem = ({ processo, isSelected, onToggle, onRemove }) => {
  // Only show if has image (marca)
  if (!processo?.marca?.[0]?.nome && !processo?.marca?.nome) return null;
  return (
    <React.Fragment>
      <ListItemButton
        component={"li"}
        sx={{
          p: (theme) => theme.spacing(1, 3),
          borderBottom: 1,
          borderBottomColor: "divider",
          "&:last-child": {
            borderBottomColor: "transparent",
          },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        {/* Remove Checkbox, add Remove button */}
        <ListItemIcon sx={{ minWidth: 42 }}>
          <IconButton edge="start" color="error" onClick={(e) => { e.stopPropagation(); onRemove(processo); }}>
            <DeleteIcon />
          </IconButton>
        </ListItemIcon>
        <ListItemAvatar>
          <Avatar
            alt={(processo?.marca && processo?.marca[0]?.nome) ? processo.marca[0].nome : "Marca"}
            src={(process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL : "") + "/public/images/marcas/" + processo.numero + ".jpg"}
            variant="rounded"
            sx={{ width: 50, height: 50 }}
          />
        </ListItemAvatar>

        <ListItemText
          sx={{
            width: "10%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          primary={
            <Typography variant="h8" mb={0.5} fontWeight={600}>
              {processo?.is_processo_de_terceiro ? (
                <Tooltip title="Terceiro">
                  <IconButton size="small">
                    <Looks3Icon color="warning" />
                  </IconButton>
                </Tooltip>
              ) : !String(processo?.procurador || '')
                  .toLowerCase()
                  .includes("vivian barbosa") ? (
                <Tooltip title="Acompanhamento">
                  <IconButton size="small">
                    <InfoIcon color="info" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Próprio">
                  <IconButton size="small">
                    <HomeIcon color="info" />
                  </IconButton>
                </Tooltip>
              )}
            </Typography>
          }
          secondary={
            <Typography
              variant={"body1"}
              fontSize={12}
              color={"text.secondary"}
              align="center"
            >
              Tipo
            </Typography>
          }
        />

        <ListItemText
          sx={{ width: "15%" }}
          primary={
            <Typography variant="h8" mb={0.5} fontWeight={600}>
              {processo?.numero || "- - -"}
            </Typography>
          }
          secondary={
            <Typography
              variant={"body1"}
              fontSize={12}
              color={"text.secondary"}
            >
              Nº Processo
            </Typography>
          }
        />       
        <ListItemText
          sx={{ width: "30%" }}
          primary={
            <Typography variant="h8" mb={0.5} fontWeight={600}>
              {processo?.marca?.[0]?.nome || processo?.nome || "-"}
            </Typography>
          }
          secondary={
            <Typography
              variant={"body1"}
              fontSize={12}
              color={"text.secondary"}
            >
              Marca
            </Typography>
          }
        />

        <ListItemText
          sx={{ width: "20%" }}
          primary={
            <Typography variant="h8" mb={0.5} fontWeight={600}>
              {processo?.procurador || "-"}
            </Typography>
          }
          secondary={
            <Typography
              variant={"body1"}
              fontSize={12}
              color={"text.secondary"}
            >
              Procurador
            </Typography>
          }
        />

        <ListItemText
          sx={{ width: "15%" }}
          primary={
            <Typography variant="h8" mb={0.5} fontWeight={600}>
              {processo?.revista_rpi?.numero || "-"}
            </Typography>
          }
          secondary={
            <Typography
              variant={"body1"}
              fontSize={12}
              color={"text.secondary"}
            >
              RPI
            </Typography>
          }
        />
      </ListItemButton>
    </React.Fragment>
  );
};

export default React.memo(SelectableProcessItem);